import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Link } from '@fcp/lib-ui';
import { Observable } from 'rxjs';
import { PrevServiceGroupContainerService } from './prev-service-group-container.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fcp-prev-service-group-container',
  template: `
    <section class="prev-list">
      <div class="prev-list__title" [innerHtml]="title | sanitizeHtml"></div>
      <div class="prev-list__subtitle" [innerHtml]="subtitle | sanitizeHtml"></div>
      <div class="prev-list__content">
        <fcp-prev-service
          *ngFor="let plano of planos | async"
          [imgFirst]="true"
          [column]="true"
          [prevService]="plano"
          (wasButtonClicked)="wasButtonClicked.emit($event)"
          (wasLinkClicked)="wasLinkClicked.emit($event)"
          (wasClickedScrollToElement)="wasClickedScrollToElement.emit($event)"
        >
        </fcp-prev-service>
      </div>
    </section>
  `
})
export class PrevServiceGroupContainerComponent implements OnInit {
  @Input() private id: string;
  @Output() public wasButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasLinkClicked: EventEmitter<Link> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();

  public planos: Observable<any>;
  public title = 'Nossas soluções';
  public subtitle = 'Planos de previdência e saúde customizados';

  constructor(
    private preServiceGroupContainerService: PrevServiceGroupContainerService
  ) {}

  ngOnInit() {
    this.planos = this.preServiceGroupContainerService
      .getGroupServicos(this.id)
      .pipe(
        map(data => {
          this.title = data.title || this.title;
          this.subtitle = data.subtitle || this.subtitle;
          return data.plans;
        })
      );
  }
}
